<template>
  <div id="survey-details">
    <div class="content-wrapper">
      <portal to="action-buttons"></portal>
      <div class="content animated fadeIn">
        <div class="card" style="padding:0px; box-shadow:unset;">
          <div
            class="card-header header-elements-inline"
            style="padding-bottom:0px;"
          >
            <h5 class="card-title">{{this.$t('event.tags.responsesSurvey')}}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('event.buttons.helpdesk')"
                  placement="top"
                >
                  <el-button
                    @click="$helpMe('https://holacon.com/product-guide/')"
                    icon="fas fa-life-ring"
                    size="mini"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('event.buttons.refresh')"
                  placement="top"
                >
                  <el-button
                    icon="fas fa-redo-alt"
                    size="mini"
                    @click="$store.dispatch('getSurveyDetails')"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <el-table
            v-loading="$store.state.surveydetails.loading"
            ref="multipleTable"
            :data="$store.state.surveydetails.items"
            style="width: 100%"
          >
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div
                  v-for="item in scope.row.answers"
                  :key="item.questionID"
                  class="col-md-12"
                  style="margin-bottom: 10px;"
                >
                  <strong
                    v-if="
                      $store.state.surveydetails.questions.some(
                        (k) => k.id == item.questionID
                      )
                    "
                    >{{
                      $store.state.surveydetails.questions.find(
                        (k) => k.id == item.questionID
                      ).title
                    }}</strong
                  >
                  <br />
                  <span
                    v-if="
                      $store.state.surveydetails.questions.some(
                        (k) => k.id == item.questionID
                      )
                    "
                    >{{ item.answer }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('event.table.participant')" property="title" min-width="200">
              <template slot-scope="scope">
                <ParticipantMini
                  :data="
                    $store.state.surveydetails.participants.find(
                      (k) => k.id == scope.row.participantID
                    )
                  "
                />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="$store.state.surveydetails.filter.page"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="$store.state.surveydetails.filter.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PageCountInfo from "./PageCountInfo";
import ParticipantMini from "./ParticipantMini";
import $ from "jquery";
export default {
  components: { PageCountInfo },
  name: "SurveyDetails",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "questionlibrary",
    };
  },
  methods: {
    handleSizeChange(take) {
      this.$store.commit("setSurveyDetailsTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setSurveyDetailsPage", page);
    },
    itemUpdated(item) {
      this.$store.dispatch("getSurveyDetails");
    },
    itemAdded(item) {
      this.$store.dispatch("getSurveyDetails");
    },
    deleteItem(index) {
      this.$store.dispatch("deleteSurveyDetail", { index, context: this });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleSubEvents", { index, value });
    },
  },
  mounted() {
    this.$store.dispatch("getSurveyDetails");
  },
  created() {},
  computed: {
    skip() {
      return (
        (this.$store.state.surveydetails.filter.page - 1) *
        this.$store.state.surveydetails.filter.take
      );
    },
    take() {
      return this.skip + this.$store.state.surveydetails.items.length;
    },
  },
  watch: {
    "$store.state.surveydetails.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getSurveyDetails");
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SurveyDetails.vue